export default "__VITE_ASSET__BvYSBRLk__"